<template>
  <div class="goods-item-wrap">
    <!-- @click="openDetail"  -->
    <a :href="itemLink" :target="isTarget_Blank()" class="goods-info-wrap">
      <LazyImage  :src="item.pic ? item.pic : ''" class="goods-pic" />
      <img
        v-if="platformLogo"
        class="goods-type-icon"
        :src="platformLogo"
        :alt="item.iconType"
        referrerpolicy="no-referrer"
      >
      <div v-else class="goods-type">{{item.iconType}}</div>
      <div class="goods-title">{{item.title}}</div>
    </a>

   
    <a
      :href="itemLink"
      :target="isTarget_Blank()"
      style="width: 169px;"
      class="goods-price"
    >{{ item.finalPrice }} {{$t('unit.yuan')}}  <template v-if="getCurrencySymbol('¥')!='¥'">（{{ getCurrencyNum(item.finalPrice) }} {{getCurrencySymbol('¥')}}）</template></a>
    <a
      :href="itemLink"
      :target="isTarget_Blank()"
      style="width: 92px;"
      class="goods-sales-num"
    >{{item.salesNum}}</a>
    <a  :target="isTarget_Blank()" :href="makeOpenImgToSearch(item.imageUrl || item.pic, item.platform)" class="popover-wrap">
      <img class="popover-img" src="/assets/imgs/indexImageSearch.svg" />
    </a>
  </div>
</template>
    
<script setup>
import useLocate from "@/components/render/uses/useLocate.js";
import { ElScrollbar } from "element-plus";
import { useMainStore } from "@/composables/store";
import { getCurrencySymbol,getCurrencyNum } from "@/utils/goods";
import { isTarget_Blank } from "@/utils/globalData";
import { $t } from "~/utils/index.js";
import { computed } from "vue";

import LazyImage from  "@/components/common/LazyImage/index.vue"
let { langJson, nowLocale, getLocaleText } = useLocate();
 

// 接收props
const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  }
});
const itemLink = computed(() => {
  return props.item?.link || `/product?detailId=${props.item?.id || ""}`;
});
const platformLogo = computed(() => {
  return String(props.item?.platform || "").trim() === "taobao"
    ? "/assets/icontb.png"
    : String(props.item?.platform || "").trim() === "1688"
      ? "/assets/icon1688.png"
      : "";
});
function openDetail() {
  // navigateTo({
  //   path: "/product",
  //   query: {
  //     detailId: props.item.id
  //   }
  // });
}

// 图搜
function makeOpenImgToSearch(url, platform) {
  if (!url) return "";
  const platformQuery =
    String(platform || "").trim() === "taobao" ? "&platform=taobao" : "";
  return '/product/search?searchType=img&imgSrc='+encodeURIComponent(url)+platformQuery;
}
</script>
    
  
<style scoped lang="less">
.goods-item-wrap {
  padding: 5px;
  display: flex;
  height: 52px;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 5px;
  position: relative;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.36);
    .popover-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 16px;
      right: 14px;
      width: 32px;
      height: 32px;
      cursor: pointer;
      background: #fff;
      border-radius: 4px;
      .popover-img {
        width: 26px;
        height: 26px;
      }
    }
  }
  .popover-wrap {
    display: none;
  }
  .goods-info-wrap {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 100px;
    padding: 0 30px 0 0;
    .goods-pic {
      width: 50px;
      height: 50px;
      min-width: 50px;
      min-height: 50px;
      margin-right: 12px;
    }
    .goods-type-icon {
      width: 18px;
      height: 18px;
      min-width: 18px;
       vertical-align: middle;
      object-fit: contain;
      margin-right: 4px;
    }
    .goods-type {
      width: 46px;
      height: 18px;
      display: inline-block;
      background: #ff4000;
      border-radius: 2px;
      margin-right: 7px;
      text-align: center;
      line-height: 18px;
      font-weight: 700;
      color: #fff;
    }
    .goods-title {
      color: #000;
      font-size: 14px;
      flex: 1;
      min-width: 100px;
      overflow: hidden;

      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .goods-price {
      font-size: 18px;
    font-weight: bold;
    color: var(--el-color-primary);
  }
  .goods-sales-num {
    font-size: 14px;
    color: #333;
  }
}
</style>
